<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="() => $router.push({ name: 'matriculas' })"
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Matrícula
        </h1>
      </v-col>
    </v-row>

    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitForm)" :disabled="submittingForm">
        <v-row v-for="(matricula, index) in form.matriculas" :key="index">
          <v-col class="pt-0 pb-0" cols="4">
            <e-label>Aluno</e-label>
            <e-autocomplete
              :items="alunosDisponiveis(index)"
              :return-object="false"
              :item-value="(aluno) => aluno.id"
              :item-text="(aluno) => aluno.nomecompleto"
              :loading="carregandoAlunos"
              :readonly="editing"
              v-model="matricula.aluno_id"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <e-label>Turma</e-label>
            <e-autocomplete
              :items="turmasList"
              :return-object="true"
              :item-text="(turma) => turma.descricao"
              :loading="carregandoTurmas"
              v-model="matricula.turma"
              @change="(turma) => changeTurma(matricula, turma)"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="3">
            <e-label>Série</e-label>
            <e-autocomplete
              :items="matricula.turma ? matricula.turma.series : []"
              :return-object="false"
              :item-value="(serie) => serie.id"
              :item-text="(serie) => serie.descricao"
              :disabled="!matricula.turma"
              v-model="matricula.serie_id"
              @change="(serie_id) => changeSerie(matricula, serie_id)"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="1">
            <v-btn
              v-if="form.matriculas.length > 1"
              class="mt-8"
              color="error"
              @click="
                () =>
                  (form.matriculas = form.matriculas.filter(
                    (matriculaObj) => matriculaObj !== matricula
                  ))
              "
              small
              ><v-icon small>fa-trash</v-icon></v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <div class="d-flex">
              <v-btn
                color="primary"
                :disabled="submittingForm"
                :loading="submittingForm"
                type="submit"
                >Enviar Dados</v-btn
              >
              <v-btn class="ml-3" v-if="!editing" color="secondary" @click="adicionarMatricula">
                Adicionar
              </v-btn>
            </div>
          </v-col>
        </v-row>

        <e-modal-info
          :showModal="openModal"
          :dadosModal="dadosModal"
          @closeModal="openModal = false"
        >
        </e-modal-info>
      </form>
    </ValidationObserver>

    <e-sheet-aviso-matricula-existente
      :sheet="sheet"
      :matricula="matricula"
      @changeSheet="sheet = $event"
    ></e-sheet-aviso-matricula-existente>
  </main-template>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ESheetAvisoMatriculaExistente from "@/components/Matriculas/ESheetAvisoMatriculaExistente.vue";
import ELabel from "../../components/ELabel.vue";

export default {
  components: {
    ELabel,
    ESheetAvisoMatriculaExistente,
  },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters("Matriculas", ["matriculas", "matriculasList", "carregandoMatriculas"]),
    // ...mapGetters("Alunos", ["carregandoAlunos"]),
    ...mapGetters("Turmas", ["turmasList", "carregandoTurmas"]),

    alunosDisponiveis() {
      return (currentIndex) => {
        const alunosSelecionados = this.form.matriculas
          .filter((_, index) => index !== currentIndex)
          .map((matricula) => matricula.aluno_id);
        return this.alunosList.filter((aluno) => !alunosSelecionados.includes(aluno.id));
      };
    },
  },
  mounted() {
    this.loadData();
    this.listarAlunos();
    // this.loadFormData();
  },
  data() {
    return {
      submittingForm: false,
      form: { matriculas: [{}] },
      series: [],
      alunosList: [],
      carregandoAlunos: false,
      disabled: true,
      sheet: false,
      matricula: {},
      openModal: false,
      dadosModal: {
        titulo: null,
        mensagem1: null,
        mensagem2: null,
        botao: null,
      },
      showModal: false,
    };
  },
  methods: {
    // ...mapActions("Matriculas", ["loadMatriculas"]),
    // ...mapActions("Alunos", ["loadAlunos"]),
    ...mapActions("Turmas", ["loadTurmas"]),
    async changeTurma(matricula, turma) {
      matricula.turma_id = turma.id;
      matricula.serie_id = turma.series[0].id;

      await this.verificaAvisoMatricula(matricula);
    },

    async changeSerie(matricula, serie_id) {
      matricula.serie_id = serie_id;

      await this.verificaAvisoMatricula(matricula);
    },

    async verificaAvisoMatricula(matricula) {
      if (!matricula.aluno_id || !matricula.serie_id) return;

      const matriculaAnterior =
        await this.$services.matriculasService.verificaAlunoPossuiMatriculaReprovadaAnoAnterior(
          matricula.aluno_id,
          matricula.serie_id
        );

      if (matriculaAnterior) {
        const reprovado = matriculaAnterior.situacao === "REPROVADO";
        this.renderModal({
          titulo: reprovado
            ? "Atenção! Aluno(a) reprovado(a) no ano anterior"
            : "Atenção! Aluno(a) aprovado(a) no ano anterior",
          mensagem1: reprovado
            ? `O aluno(a) ${matriculaAnterior.aluno.nomecompleto} possui matrícula reprovada no ano anterior na turma ${matriculaAnterior.turma.descricao} (Série: ${matriculaAnterior.serie.descricao}).`
            : `O aluno(a) ${matriculaAnterior.aluno.nomecompleto} foi aprovado(a) no ano anterior na turma ${matriculaAnterior.turma.descricao} (Série: ${matriculaAnterior.serie.descricao}).`,
          mensagem2: "Certifique-se de matricular o aluno(a) na série correta.",
          botao: "Ok, estou ciente",
        });
      }
    },

    renderModal(dados) {
      this.dadosModal = dados;
      this.openModal = true;
    },

    adicionarMatricula() {
      this.form.matriculas.push({});
    },
    async listarAlunos() {
      this.carregandoAlunos = true;
      try {
        this.alunosList = await this.$services.alunosService.syncAll();
        this.carregandoAlunos = false;
      } catch (error) {
        this.$handleError(error);
      }
    },
    // async verificarSeAlunoPossuiMatriculaNoMunicipio(matricula) {
    //   try {
    //     await this.$services.matriculasService
    //       .verificarSeAlunoPossuiMatriculaNoMunicipio(matricula)
    //       .then((response) => {
    //         if (response === "") {
    //           this.sheet = false;
    //           return (this.disabled = false);
    //         }
    //         this.form.matriculas = this.form.matriculas.filter(
    //           (matriculaObj) => matriculaObj.aluno_id !== matricula
    //         );
    //         this.matricula = response;
    //         this.sheet = true;
    //         return (this.disabled = true);
    //       })
    //       .catch(() => {
    //         this.disabled = true;
    //       });
    //   } catch (error) {
    //     this.$handleError(error);
    //   }
    // },
    async submitForm() {
      this.form.especial = Boolean(this.form.especial);
      this.form.recursos_saeb = this.recursos_saeb;
      this.submittingForm = true;
      try {
        if (this.editing) {
          await this.$services.matriculasService.atualizarMatricula(this.form.matriculas[0]);
        } else {
          await this.$services.matriculasService.matricular(this.form);
        }
        this.$toast.success("Matricula Atualizada com sucesso");
        this.$router.push({ name: "matriculas" });
      } catch (error) {
        this.$handleError(error);
      }
      this.submittingForm = false;
    },
    async loadData() {
      this.loadFormData();
      try {
        if (
          this.matriculasList.length === 0 ||
          this.alunosList.length === 0 ||
          this.turmasList.length === 0
        ) {
          this.$loaderService.open("Carregando dados");
        }
        await Promise.all([this.listarAlunos(), this.loadTurmas()]);
        this.$loaderService.close();
        this.$forceUpdate();
        this.loadFormData();
      } catch (error) {
        this.$handleError(error);
      }
    },
    loadFormData() {
      if (!this.matriculas || !this.editing) {
        this.form = { matriculas: [{}] };
        return;
      }
      const { matricula_id } = this.$route.params;
      const matricula = this.matriculas.get(parseInt(matricula_id, 10));
      if (matricula) this.form = { matriculas: [matricula] };
    },
  },
};
</script>

<style></style>
